export const Tips = Object.freeze({
  ten: { cents: null, coeff: 0.1, text: "10%" },
  fifteen: { cents: null, coeff: 0.15, text: "15%" },
  twenty: { cents: null, coeff: 0.2, text: "20%" },
  other: { cents: 0, coeff: null, text: "Other" },
});
